import { DO_INIT_MENU, DO_ACTIVE_PAGE, DO_CHANGE_SIMPLE_MODE, DO_CHANGE_DETAIL_MODE } from '../actions/menu/index';

const doMenu = (state, action) => {
  switch (action.type) {
    case DO_INIT_MENU:
      return {
        activePage: null,
        displayMode: 'simple-mode'
      }
    case DO_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.params.activePage,
      }
    case DO_CHANGE_SIMPLE_MODE:
      return {
        ...state,
        displayMode: 'simple-mode'
      }
    case DO_CHANGE_DETAIL_MODE:
      return {
        ...state,
        displayMode: 'detail-mode'
      }
    default:
      return state;
    }
}

const menuReducers = (state = {
  activePage: null,
  displayMode: 'simple-mode'
}, action) => {
  switch (action.type) {
    default:
      return doMenu(state, action);
  }
}

export default menuReducers;